import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {BanUserModel} from "src/app/models/common/ban-user-model";
import {BackendListModel} from "src/app/models/common/list.model";
import {MyProfileModel} from "src/app/models/common/myprofile-model";
import {MyTeamModel} from "src/app/models/common/myteam-model";
import {ForceResetPasswordModel} from "src/app/models/common/reset-password-model";
import {UserActivityModel} from "src/app/models/common/user-activity-model";
import {UserRole} from "src/app/models/common/user-role";
import {ExternalUserModel, UserModel} from "src/app/models/common/usermodel";
import {ApiRoutes} from "../apiroutes";
import {AuthService} from "../auth.service";
import {ExternalMyTeamModel} from "src/app/components/master-data/user-form-external/external-my-team.model";

@Injectable({
    providedIn: 'root'
})

export class UserMasterApiService {
    base_url = ApiRoutes.Company;
    base_url_user_activity = ApiRoutes.Core;

    GENDER_OBJS = [
        {
            id: 1000,
            value: 'Male'
        },
        {
            id: 2000,
            value: 'Female'
        },
        {
            id: 3000,
            value: 'Non-Binary'
        }
    ]

    constructor(private http: HttpClient, private authService: AuthService) { }

    // GET User List
    getUser(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<UserModel>> {
        let url = `${this.base_url}internal_profile/`
        let urlObj = new URL(url);
        let current_user = JSON.parse(localStorage.getItem("current_user"));
        urlObj.searchParams.append(`search`, String(search));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('role', String(current_user.role));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<UserModel>>(String(urlObj));
    }

    // GET External User List
    getExternalUser(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ExternalUserModel>> {
        let url = `${this.base_url}external/`;
        let urlObj = new URL(url);
        let current_user = JSON.parse(localStorage.getItem("current_user"));
        urlObj.searchParams.append(`search`, String(search));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<ExternalUserModel>>(String(urlObj));
    }

    // GET My Team list
    getMyTeam(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<MyTeamModel>> {
        let url = `${this.base_url}my-team/`
        let urlObj = new URL(url);
        urlObj.searchParams.append(`search`, String(search));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<MyTeamModel>>(String(urlObj));
    }

    getExternalMyTeam(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ExternalMyTeamModel>> {
        let url = `${this.base_url}external-my-team/`
        let urlObj = new URL(url);
        urlObj.searchParams.append(`search`, String(search));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<ExternalMyTeamModel>>(String(urlObj));
    }

    // GET User by ID
    getUserByID(userId: string): Observable<BackendListModel<UserModel>> {
        let url = `${this.base_url}internal_profile/${userId}/`
        return this.http.get<BackendListModel<UserModel>>(url);
    }

    // GET User List by ID
    getUserListByID(userId: string): Observable<BackendListModel<UserModel>> {
        let url = `${this.base_url}user_list/${userId}/`
        return this.http.get<BackendListModel<UserModel>>(url);
    }

    // POST User
    postUser(data: UserModel) {
        let url = `${this.base_url}internal_profile/`;
        return this.http.post<UserModel>(url, data);
    }

    // PUT User
    updateUser(userId: string, data: UserModel) {
        let url = `${this.base_url}internal_profile/${userId}/`;
        return this.http.put<UserModel>(url, data);
    }

    // GET User Roles
    getRole(): Observable<BackendListModel<UserRole>> {
        let url = `${this.base_url}profile_role/`
        return this.http.get<BackendListModel<UserRole>>(url);
    }

    // GET User Roles by Type
    getRoleByType(type: number): Observable<BackendListModel<UserRole>> {
        let url = `${this.base_url}profile_role/?type=${type}`
        return this.http.get<BackendListModel<UserRole>>(url);
    }

    // GET User login activity
    getUserActivity(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<UserActivityModel>> {
        let url = `${this.base_url_user_activity}user_activity/`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('search', String(search));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<UserActivityModel>>(String(urlObj));
    }

    // BAN User
    banUser(data: BanUserModel) {
        let url = `${this.base_url}ban-user/`;
        return this.http.post<BanUserModel>(url, data);
    }

    // Force RESET User password
    resetPassword(data: ForceResetPasswordModel) {
        let url = `${this.base_url}force-reset-password/`;
        return this.http.post<ForceResetPasswordModel>(url, data);
    }

    // GET My-Profile
    getMyProfile(): Observable<MyProfileModel> {
        let url = `${this.base_url}my-profile/`;
        return this.http.get<MyProfileModel>(url);
    }

    // PUT My-Profile Details
    updateMyProfile(data: MyProfileModel) {
        let keysToTransform = ['country', 'profile_role', 'company_logo', 'e_sign', 'picture', 'cover_picture']
        let url = `${this.base_url}my-profile/`;
        return this.http.put<MyProfileModel>(url, this.filterData(data, keysToTransform));
    }

    updateLandingPage(data) {
        let url = `${this.base_url}my-profile-default-page/`;
        return this.http.put(url, data);
    }

    skipTutorialPage(data) {
        let url = `${this.base_url}skip-tutorial-page/`;
        return this.http.put(url, data);
    }

    filterData(profileData, keyArray) {
        let data = { ...profileData }
        for (const key of keyArray) {
            if (data[key] != null && data[key] != '' && typeof data[key] == 'object')
                data[key] = data[key].id;
        }
        // if (data.company_logo) {
        //     data.company_logo = data.company_logo['id']
        // }
        // if (data.e_sign) {
        //     data.e_sign = data.e_sign['id']
        // }
        // if (data.picture) {
        //     data.picture = data.picture['id']
        // }
        // if (data.cover_picture) {
        //     data.cover_picture = data.cover_picture['id']
        // }
        return data;
    }

    getIdListFromObjList(objList: any[]) {
        let objIds = []
        for (let obj of objList) {
            objIds.push(obj.id);
        }
        return objIds;
    }
}
